import { Roles } from '../auth/constants/AuthConstants';
import { useMemo } from 'react';
import {
  REPORT_TYPE_DISPLAY_NAMES,
  TEAM_TYPE_DISPLAY_NAMES,
  VIEW_DEFINITION_URL
} from './constant';

const checkRoles = (
  roles: string[] = []
): {
  isNaviTeamLead: () => boolean;
  isFieldTeamLeadExcluding1630: () => boolean;
} => {
  const isNaviTeamLead = () => roles?.includes(Roles.ROLE_TEAM_LEAD);
  const isFieldTeamLeadExcluding1630 = () =>
    (roles?.includes(Roles.ROLE_NAVI_FIELD_EXTERNAL_TEAM_LEAD) ||
      roles?.includes(Roles.ROLE_NAVI_FIELD_AGENCY_TEAM_LEAD)) &&
    !roles?.includes(Roles.ROLE_NAVI_16_30_FIELD_TEAM_LEAD);

  return {
    isNaviTeamLead,
    isFieldTeamLeadExcluding1630
  };
};

export const useUserRoles = (roles: string[] = []): ReturnType<typeof checkRoles> => {
  return useMemo(() => checkRoles(roles), [roles]);
};

export const isUnifiedCaseLevelReportVisible = (roles: string[]): boolean =>
  checkRoles(roles).isNaviTeamLead();

export const isFeedbackReportVisible = (roles: string[]): boolean =>
  checkRoles(roles).isFieldTeamLeadExcluding1630();

export const isPaymentReportVisible = (roles: string[]): boolean =>
  checkRoles(roles).isFieldTeamLeadExcluding1630();

export const useUnifiedCaseLevelReportVisible = (roles: string[] = []): boolean => {
  const roleUtils = useUserRoles(roles);
  return roleUtils.isNaviTeamLead();
};

export const useFeedbackReportVisible = (roles: string[] = []): boolean => {
  const roleUtils = useUserRoles(roles);
  return roleUtils.isFieldTeamLeadExcluding1630();
};

export const usePaymentReportVisible = (roles: string[] = []): boolean => {
  const roleUtils = useUserRoles(roles);
  return roleUtils.isFieldTeamLeadExcluding1630();
};

export const isExternalAgentAllocationReportVisible = (roles: string[] = []): boolean => {
  return checkRoles(roles).isNaviTeamLead();
};
export const formatRequestedAt = (dateStr: string): string => {
  if (!dateStr) return '';
  const [date, month, year, time, period] = dateStr.split(' ');
  return `${date} ${month}, ${year} | ${time} ${period}`;
};

export const getReportTypeDisplayName = (reportType: string): string => {
  return (
    REPORT_TYPE_DISPLAY_NAMES[reportType as keyof typeof REPORT_TYPE_DISPLAY_NAMES] || reportType
  );
};

export const getTeamTypeDisplayName = (teamType: string): string => {
  return TEAM_TYPE_DISPLAY_NAMES[teamType as keyof typeof TEAM_TYPE_DISPLAY_NAMES] || teamType;
};

export const handleRedirection = () => {
  window.open(`${VIEW_DEFINITION_URL}`);
};

export const calculateTableHeight = (rowCount: number) => {
  const rowHeight = 70; // Each row is 70px
  const headerHeight = 50; // Approximate header height
  const maxHeight = 600; // Maximum height to prevent excessive scrolling

  const calculatedHeight = headerHeight + rowCount * rowHeight;
  return Math.min(calculatedHeight, maxHeight);
};
